export default __webpack_public_path__ + "static/media/book.195189b5.svg";